import * as React from "react";

const SecurityIconSVG = ({
    color = "#F8FAFC"
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill={color}
            d="m18.95 23.55 5.65-5.65-1.425-1.425L18.95 20.7l-2.1-2.1-1.425 1.425zM20 30q-3.476-.875-5.738-3.987Q12 22.899 12 19.1V13l8-3 8 3v6.1q0 3.8-2.262 6.913Q23.475 29.125 20 30m0-2.1q2.6-.825 4.3-3.3t1.7-5.5v-4.725l-6-2.25-6 2.25V19.1q0 3.025 1.7 5.5t4.3 3.3"
        ></path>
    </svg>
);

export default SecurityIconSVG;
